import { useState } from "react";
import useAppData from "../../../hooks/useAppData";
import ReactGA from "react-ga4";
import { Send, X, MessageCircle } from "lucide-react";

const Whatsapp = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [message, setMessage] = useState("");

	const { settings } = useAppData();
	const rawNumber = settings?.whatsapp_number || "971000000000"; // Fallback to a UAE format
	const cleanNumber = rawNumber.replace(/\D/g, "");

	const handleSend = (e) => {
		let encodedMessage;
		encodedMessage = encodeURIComponent(message);
		if (!message.trim()) {
			encodedMessage = encodeURIComponent(
				"Hello! I need help with my shipment.",
			);
		}
		ReactGA.event({
			category: "Conversion",
			action: "whatsapp_chat_started",
			label: message.trim() ? "Custom Message" : "Default Message",
		});
		const url = `https://wa.me/${cleanNumber}?text=${encodedMessage}`;
		window.open(url, "_blank");
		setMessage("");
		setIsOpen(false);
	};

	return (
		<div className="fixed bottom-[5%] right-[2%] z-999 flex flex-col items-end font-sans">
			{/* Chat Box */}
			{isOpen && (
				<div className="mb-4 w-[320px] bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden animate-in slide-in-from-bottom-5 duration-300">
					{/* Header */}
					<div className="bg-[#075e54] p-4 text-white flex justify-between items-center">
						<div className="flex items-center gap-3">
							<div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
								<MessageCircle size={24} />
							</div>
							<div>
								<p className="font-bold text-sm">Customer Support</p>
								<p className="text-xs opacity-80">
									Typically replies instantly
								</p>
							</div>
						</div>
						<button
							onClick={() => setIsOpen(false)}
							className="ha:bg-white/10 rounded-full p-1"
						>
							<X size={20} />
						</button>
					</div>

					{/* Chat Body */}
					<div className="p-4 bg-[#e5ddd5] min-h-50">
						<div className="bg-white p-3 rounded-lg rounded-tl-none shadow-sm max-w-[80%] text-sm text-gray-700">
							Hi there! 👋 <br /> How can we help you with your shipment today?
						</div>
					</div>

					{/* Input Area */}
					<form
						onSubmit={handleSend}
						className="p-3 bg-white flex gap-2 border-t"
					>
						<input
							type="text"
							placeholder="Type a message..."
							value={message}
							onChange={(e) => setMessage(e.target.value)}
							className="flex-1 bg-gray-100 border-none rounded-full px-4 py-2 text-sm focus:ring-2 focus:ring-[#25D366] outline-none text-black"
						/>
						<button
							type="submit"
							className="bg-[#25D366] text-white p-2 rounded-full ha:bg-[#128c7e] transition-colors"
						>
							<Send size={18} />
						</button>
					</form>
				</div>
			)}

			{/* Main Toggle Button */}
			<button
				onClick={() => setIsOpen(!isOpen)}
				className="group flex items-center gap-3"
			>
				{/* Custom Tooltip (visible only when closed) */}
				{!isOpen && (
					<span className="bg-white text-gray-800 text-sm font-semibold py-2 px-4 rounded-xl shadow-lg border border-gray-50 opacity-0 gh:opacity-100 transition-opacity">
						Chat with us
					</span>
				)}

				<div
					className={`p-2 relative rounded-full shadow-2xl transition-all duration-300 ${isOpen ? "bg-gray-200 rotate-90" : "bg-white ha:scale-110"}`}
				>
					{isOpen ? (
						<X className="text-gray-600" size={40} />
					) : (
						<img
							src="/assets/images/whatsapp.png"
							alt="WA"
							className="w-12 h-12 object-contain"
						/>
					)}

					{/* Subtle Pulse when closed */}
					{!isOpen && (
						<span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-50"></span>
					)}
				</div>
			</button>
		</div>
	);
};

export default Whatsapp;
